import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Typography,
  Form,
  Input,
  Button,
  Spin,
  notification,
  Row,
  Col,
  theme,
} from "antd";
import "../Signup/Signup.css";
import UserApi from "../common/Apis/UserApi";
import RegisterForm from "../common/CommonUI/RegisterForm/RegisterForm";

const { Title } = Typography;
const Signup = (props) => {
  const { useToken } = theme;
  const { token } = useToken();
const [loadings, setLoadings] = useState(false);

  const handleSubmit = (data) => {
    setLoadings(true);
    localStorage.setItem("userEmail", data.email);

    // requestAptitudeTest Api
    const formData = new FormData();
    formData.append("email", data.email);
    formData.append("admin", true);

    UserApi.requestAptitudeTest(formData)
      .then((response) => {
        setLoadings(false);
        console.log(response);
        notification.open({
          message: (
            <span style={{ fontWeight: "bold" }}>Aptitude Test Sent</span>
          ),
          description: "Please check your inbox",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
      })
      .catch((err) => {
        setLoadings(false);
        // Error Notification
        console.log(err);
        if (err) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#ffb3b3",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <>
      <div className="container container-body form-container">
        <div className="row justify-content-center">
          <div className="col-xl-9 col-lg-9 col-md-11 IpadView content-border my-1">
            <Row gutter={24}>
              <RegisterForm />
              <Col
                lg={12}
                md={24}
                className="py-4"
                style={{ boxShadow: "8px 8px 16px -4px rgba(0, 0, 0, 0.1)" }}
              >
                <Form
                  name="nest-messages"
                  layout="vertical"
                  onFinish={handleSubmit}
                  className="py-1 px-4 Register-form"
                >
                  <div className="d-flex justify-content-center pb-2">
                    <img
                      src="/assest/Images/Logo/logo.png"
                      className="logo-png"
                    />
                  </div>

                  <Title
                    style={{
                      textAlign: "center",
                      color: "black",
                      marginBottom: 15,
                    }}
                    level={4}
                    className="Primary-Font"
                  >
                    Create your foodflow account
                  </Title>

                  <>
                    <Form.Item
                      name="email"
                      className="text-lable"
                      rules={[
                        {
                          required: true,
                          type: "email",
                          message: "The input is not valid E-mail!",
                        },
                      ]}
                    >
                      <Input
                        type="email"
                        className="form-control control-input"
                        placeholder="Enter your email"
                      />
                    </Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="btn btn-primary mt-0 w-100 mb-2"
                      style={{ background: token.colorPrimary }}
                      disabled={loadings == true}
                    >
                      Continue {loadings == true && <Spin className="px-2" />}
                    </Button>
                    <p style={{ fontWeight: "bold" }}>INSTRUCTIONS :</p>
                    <div className="instruction-box">
                      <ul>
                        <li>
                          Enter your email address in the input field above.
                        </li>
                        <li>
                          Click the <b>"Continue"</b> button to proceed with the
                          registration.
                        </li>
                        <li>
                          Check your inbox regularly for an email with the
                          aptitude test instructions.
                        </li>
                        <li>
                          Follow the instructions provided in the email to
                          complete the aptitude test.
                        </li>
                        <li>
                          Once you have completed the test, your company will be
                          able to register on the iVA Connect platform.
                        </li>
                      </ul>
                    </div>
                    <p className="content signup-content pt-2">
                      Already a member?{" "}
                      <Link to={"/"} className="content-link">
                        Sign In
                      </Link>
                    </p>
                  </>
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
